export class SurfaceColorDto {
	public id: number = 0;
	public name: string = "";
	public ralCode: string = "";
	public hexCode: string = "";
}
